export const FileTranslationsTranslateStatus = {
  TRANSLATED_REQUESTED: 'TRANSLATED_REQUESTED',
  TRANSLATING: 'TRANSLATING',
  TRANSLATED: 'TRANSLATED',
  TRANSLATED_UPLOADED: 'TRANSLATED_UPLOADED',
  ERROR: 'ERROR',
} as const;
